/*
* <license header>
*/

import React, { useState } from 'react'
import { Flex, View } from '@adobe/react-spectrum'
import { AssistantHeader } from './assistant/AssistantHeader'
import { ConversationSidebar } from './assistant/ConversationSidebar'
import { ChatSection } from './assistant/ChatSection'
import { MessageSection } from './assistant/MessageSection'

export const AskAssistant = ({ runtime, ims }) => {
  const [activeConversationId, setActiveConversationId] = useState('current')
  const [selectedPrompt, setSelectedPrompt] = useState('')

  const handleSelectPrompt = (prompt) => {
    setSelectedPrompt(prompt)
  }

  const handleSend = (message) => {
    console.log('Send:', message)
    setSelectedPrompt('')
  }

  return (
    <View
      width="100%"
      height="100%"
      padding="size-400"
      UNSAFE_style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
        paddingBottom: '2.5rem'
      }}
    >
      <AssistantHeader />
      <Flex direction="row" flex={1} minHeight={0} UNSAFE_style={{ overflow: 'hidden' }} UNSAFE_className="AskAssistant-layout">
        <ConversationSidebar
          activeConversationId={activeConversationId}
          onSelectConversation={setActiveConversationId}
        />
        <View
          flex={1}
          UNSAFE_style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '1.5rem',
            overflow: 'auto',
            minWidth: 0
          }}
        >
          <Flex direction="column" gap="size-300" flex={1} minHeight={0}>
            <ChatSection onSelectPrompt={handleSelectPrompt} />
            <MessageSection
              key={selectedPrompt}
              initialMessage={selectedPrompt}
              onSend={handleSend}
            />
          </Flex>
        </View>
      </Flex>
    </View>
  )
}
